import { 
    TECHNICALREPRESENTATIVE_BEGIN,
    TECHNICALREPRESENTATIVE_ADD,
    TECHNICALREPRESENTATIVE_FAILURE,
    TECHNICALREPRESENTATIVE_CLEAR,

    TECHNICALREPRESENTATIVE_FILTER_BEGIN,
    TECHNICALREPRESENTATIVE_FILTER_SUCCESS,
    TECHNICALREPRESENTATIVE_FILTER_FAILURE,
    TECHNICALREPRESENTATIVE_FILTER_CLEAR

} from 'app/actions/TechnicalRepresentativeActions';

const initialState = {
    allIds: [],
    filterData: [],
	isLoading: false,
};

export default function TechnicalRepresentativeReducer (state = initialState, action) {
	switch (action.type) {
        case TECHNICALREPRESENTATIVE_BEGIN: 
			return {
				...state,
				isLoading: true
			}
        case TECHNICALREPRESENTATIVE_ADD:
			let allIds =action.payload.data.Data;
			return {
				...state,
				allIds,
				isLoading: false,
            };
        case TECHNICALREPRESENTATIVE_CLEAR:
            return {
                ...state,
                allIds: [],
                isLoading: false,
            }
        case TECHNICALREPRESENTATIVE_FAILURE: 
			return {
				...state,
				isLoading: false
            }
        case TECHNICALREPRESENTATIVE_FILTER_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case TECHNICALREPRESENTATIVE_FILTER_SUCCESS:
            let filterData = [...new Set(state.filterData.concat(action.payload.filterData))];
            return {
                ...state,
                filterData,
                isLoading: false,
            };
        case TECHNICALREPRESENTATIVE_FILTER_CLEAR:
            return {
                ...state,
                filterData: [],
                isLoading: false,
            }
        case TECHNICALREPRESENTATIVE_FILTER_FAILURE:
            return {
                ...state,
                isLoading: false
            }
		default:
			return state;
	}
};

export const getTechnicalRepresentative = state => {
	return state.allIds;
}

export const getIsLoadingTechnicalRepresentative = state => {
    return state.isLoading;
}

export const getTechnicalRepresentativeFilter = state => {
    return state.filterData
}
export const getIsLoadingTechnicalRepresentativeFilter = state => {
    return state.isLoading;
}